import { createStyles } from '@material-ui/core/styles';

export function styles() {
  return createStyles({
    root: {},
    select: {},
    label: {},
    errorText: {},
  });
}
